import React from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

import Context from "../../Context";
import EssenceReference from "../Essence/EssenceReference";

let searchTimeout = null;

export default class SuperSelect extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      items: [],
      value: this.props.defaultValue,
      referenceShow: false,
      inputValue: "",
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.defaultValue !== this.props.defaultValue) {
      this.setState({ value: this.props.defaultValue }, () => {
        this.loadDefaultValue();
        this.handleSingleItem(prevProps.defaultValue, this.props.defaultValue);
      });
    }
  }

  hasManageRights = () => {
    let access = this.context.user.classAccess[this.props.essence] || {};
    if (access.c || access.u || access.d) {
      return true;
    }
    return false;
  };

  createSearch = () => {
    let search = [];
    if (!this.props.anyState) {
      search.push({
        field: "statetypecode",
        compare: "EQL",
        value: "enabled",
      });
    }
    if (this.props.type) {
      search.push({
        field: "typecode",
        compare: "EQL",
        value: this.props.type,
      });
    }

    if (this.props.search) {
      search = search.concat(this.props.search);
    }
    return search;
  };

  handleSingleItem = (prevValue, newValue) => {
    if (this.state.items.length === 1 && this.props.onSingleItem) {
      let item = this.state.items[0];
      if (!newValue) {
        this.props.onSingleItem(item);
      }
    }
  };

  loadDefaultValue = async () => {
    const {
      async,
      defaultValue,
      idField,
      nameField,
      essence,
      forcePath,
    } = this.props;

    if (async && defaultValue) {
      if (this.getReferenceValue(defaultValue, this.state.items)) {
        return;
      }
      this.setState({ pending: true });
      let search = this.createSearch();
      search.push({
        field: idField,
        compare: "EQL",
        value: defaultValue,
      });
      let path = forcePath || `/${essence}/list`;
      let defaultItem = await this.context.api.qo(path, {
        search,
        reclimit: 1,
      });
      let item = defaultItem[defaultValue];
      if (item) {
        this.setState((state) => {
          let { items } = state;
          let label = this.props.labelFn
            ? this.props.labelFn(item)
            : item[nameField];
          items.push({
            value: item[idField],
            code: item.code,
            label,
          });
          return { items };
        });
      }
      this.setState({ pending: false });
    }
  };

  load = async () => {
    const { nameField, idField, essence, orderby, async } = this.props;
    this.setState({ pending: true });
    let search = this.createSearch();

    if (async) {
      if (this.state.inputValue) {
        if (this.props.searchByCode) {
          search.push({
            lstr: "(",
            field: nameField,
            compare: "IKE",
            value: `%${this.state.inputValue}%`,
          });
          search.push({
            condition: "OR",
            field: "code",
            compare: "IKE",
            value: `%${this.state.inputValue}%`,
            rstr: ")",
          });
        } else {
          search.push({
            field: nameField,
            compare: "IKE",
            value: `%${this.state.inputValue}%`,
          });
        }
      }
    }

    let defaultOrder = ["operdate DESC", `${nameField} ASC`];

    let items = [];
    let path = this.props.forcePath || `/${essence}/list`;

    let extraFields = this.props.extraFields || [];

    let queryParams = this.props.forceQueryParams || {
      fields: [idField, nameField, "code", ...extraFields],
      search,
      orderby: orderby || defaultOrder,
      reclimit: this.props.reclimit || 500,
    };

    let fetchFn = this.props.cache ? this.context.api.qac : this.context.api.qa;

    let itemsQuery = await fetchFn(path, queryParams);
    if (Array.isArray(itemsQuery)) {
      itemsQuery.forEach((item) => {
        let label = this.props.labelFn
          ? this.props.labelFn(item)
          : item[nameField];

        items.push({
          ...item,
          value: item[idField],
          code: item.code,
          label,
        });
      });
    }

    this.setState({ items, pending: false }, () => {
      this.loadDefaultValue();
      this.handleSingleItem();
    });
  };

  getReferenceValue = (value, reference) => {
    if (Array.isArray(reference)) {
      if (Array.isArray(value)) {
        return reference.filter((item) => value.includes(item.value));
      } else {
        return reference.find((item) => item.value === value) || null;
      }
    }
    return {};
  };
  onReferenceSelect = async (item) => {
    const { idField } = this.props;
    await this.load();
    this.onChange({ value: item[idField] });
  };
  onReferenceHide = () => {
    this.load();
    this.setState({ referenceShow: false });
  };
  onReferenceShow = () => {
    this.setState({ referenceShow: true });
  };
  onChange = (result) => {
    let value = null;
    if (Array.isArray(result)) {
      let arValues = [];
      result.forEach((resultItem) => arValues.push(resultItem.value));
      value = arValues;
    } else {
      value = result ? result.value : null;
    }
    this.setState({ value });
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };
  onCreate = async (value) => {
    const { nameField, idField, essence } = this.props;

    if (value) {
      this.setState({ pending: true });
      let saveData = {};
      saveData[nameField] = value;
      if (this.props.type) {
        saveData.type = this.context.getType(this.props.type);
      }
      let result = await this.context.api.q(`/${essence}/set`, saveData);
      if (result) {
        await this.load();
        this.onChange({ value: result[idField] });
      } else {
        this.context.toast("Не удалось добавить запись", "error");
        this.setState({ pending: false });
      }
    }
  };
  onInputChange = (inputValue) => {
    if (this.props.async && inputValue) {
      this.setState({ inputValue, items: [], pending: true });
      window.clearTimeout(searchTimeout);
      searchTimeout = window.setTimeout(() => {
        this.load();
      }, this.props.asyncTimeout || 1000);
    } else {
      this.setState({ inputValue });
    }
  };
  render() {
    const { pending, items, value, referenceShow } = this.state;
    const { reference, button, grey, light, refBtnClass } = this.props;

    const creatable = this.props.add && this.hasManageRights();

    const SelectComponent = creatable ? CreatableSelect : Select;

    const filterOption = (option, inputValue) => {
      let reg = new RegExp(this.context.api.regexEscape(inputValue), "gi");
      let optionData = option.data || {};
      if (this.props.searchByCode && optionData.code) {
        if ((optionData.code.toString().match(reg) || []).length > 0) {
          return true;
        }
      }
      if (option.label) {
        return (option.label.toString().match(reg) || []).length > 0;
      }
    };

    let selectClasses = ["from-control", "react-select"];
    if (grey) selectClasses.push("react-select-grey");
    if (light) selectClasses.push("react-select-light");

    const SelectItself = (
      <SelectComponent
        isLoading={pending}
        value={this.getReferenceValue(value, items)}
        onChange={this.onChange}
        onCreateOption={this.onCreate}
        className={selectClasses.join(" ")}
        classNamePrefix="react-select-inner"
        options={items}
        formatOptionLabel={this.props.formatOptionLabel}
        placeholder={this.props.placeholder || ""}
        noOptionsMessage={({ inputValue }) =>
          `Ничего не найдено по запросу ${inputValue}`
        }
        loadingMessage={() => (
          <span>
            Идет поиск{" "}
            <span className="text-primary">{this.state.inputValue}</span>
          </span>
        )}
        formatCreateLabel={(inputValue) => `Добавить: ${inputValue}`}
        filterOption={filterOption}
        isClearable={this.props.isClearable}
        isMulti={this.props.multiple ? true : false}
        inputValue={this.state.inputValue}
        onInputChange={this.onInputChange}
      />
    );

    const isGroup = reference || button;

    let ReferenceComponent = null;
    let ReferenceButton = null;
    if (reference) {
      ReferenceComponent = (
        <EssenceReference
          {...reference}
          show={referenceShow}
          onHide={this.onReferenceHide}
          onSelect={this.onReferenceSelect}
        />
      );
      ReferenceButton = (
        <div
          onClick={this.onReferenceShow}
          title="Открыть справочник"
          className={`btn btn-icon  ${refBtnClass} ${
            grey ? "btn-light" : "border text-hover-dark-50"
          }`}
        >
          <i className="fa fa-navicon"></i>
        </div>
      );
    }

    return (
      <>
        {!isGroup && <>{SelectItself}</>}
        {isGroup && (
          <div className="react-select-group">
            {SelectItself}
            {ReferenceButton}
            {button}
          </div>
        )}
        {ReferenceComponent}
      </>
    );
  }
}
